import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { getCompanyAddress } from '@helpers/companies';

const Questions = ({ locationSurveyId, location }) => {
    const iframeRef = useRef(null);
    const { watch } = useFormContext();

    const questions = watch('questions');

    useEffect(() => {
        const controller = new AbortController();
        const data = {
            locationName: location.locationName,
            businessAddress: getCompanyAddress(location.addressLine1, location.city),
            hasBusinessAddress: location.hasBusinessAddress,
            questions,
        };
        const sendUpdatedData = event => {
            if (event.origin === process.env.REACT_APP_SURVEY_DOMAIN) {
                const message = event.data;
                if (message.type === 'pl-preview-iframe-loaded') {
                    iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-questions', data }, '*');
                }
            }
        };
        iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-questions', data }, '*');
        window.addEventListener('message', sendUpdatedData, { signal: controller.signal });
        return () => controller.abort();
    }, [location, questions]);

    return (
        <iframe
            ref={iframeRef}
            allow="autoplay"
            width="100%"
            height="100%"
            src={`${process.env.REACT_APP_SURVEY_DOMAIN}/preview/questions/${locationSurveyId}`}
            frameBorder="0"
        ></iframe>
    );
};

export default Questions;
